import React, { Component, Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import compose from "ramda/src/compose";
import { func } from "prop-types";
import { translate } from "react-i18next";
import * as Yup from "yup";
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup";

import {
  Button,
  FloatLabelInput,
  FloatLabelTextArea,
  Form,
} from "shared/components";
import Loader from "../../../../../components/Loading";
import * as Mask from "../../../../../services/utils/mask";
import * as Validation from "../../../../../services/utils/validation";
import { createCommonIncident } from "../../../../../services/state/actions";
import styles from "../../../styles.css";

class ClearChannelIntermittentForm extends Component {
  renderInternCallInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="internCall"
        name="internCall"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderProblemTimeInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="type"
        name="type"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderReasonInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelTextArea
        id="description"
        name="description"
        label={field.label}
        preset="modalTextArea"
        onChange={field.input.onChange}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
        noResize
      />
    );
  };

  renderProblemTimeInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="problemTime"
        name="problemTime"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };
  renderHowFiguredTheProblemInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="howFiguredTheProblem"
        name="howFiguredTheProblem"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };
  renderTestingSchedulerInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="testingScheduler"
        name="testingScheduler"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };
  rendercontactPhoneInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="contactPhone"
        name="contactPhone"
        onChange={field.input.onChange}
        label={field.label}
        maxLength="15"
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  onSubmit = (form) => {
    const { t, reason, createCommonIncident, onNextStep, onReset } = this.props;

    const checklist = {
      data: { ...form, reason },
      labels: {
        reason: t("MSG_0397"),
        testingScheduler: t("MSG_0205"),
        description: t("MSG_0202"),
        problemTime: t("MSG_0225"),
        internCall: t("MSG_0203"),
        howFiguredTheProblem: t("MSG_0218"),
        contactPhone: t("MSG_0206"),
      },
    };

    return createCommonIncident(checklist, onNextStep, onReset);
  };

  render() {
    const { t, handleSubmit, submitting, onPreviousStep } = this.props;
    return (
      <Fragment>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <p className={styles.formInstructions}>{t("MSG_0211")}</p>
          <Field
            id="description"
            name="description"
            component={this.renderReasonInput}
            label={t("MSG_0202")}
          />
          <Field
            id="internCall"
            name="internCall"
            component={this.renderInternCallInput}
            label={t("MSG_0203")}
          />
          <Field
            id="problemTime"
            name="problemTime"
            component={this.renderProblemTimeInput}
            label={t("MSG_0225")}
            format={Mask.time}
          />
          <Field
            id="howFiguredTheProblem"
            name="howFiguredTheProblem"
            component={this.renderHowFiguredTheProblemInput}
            label={t("MSG_0218")}
          />
          <Field
            id="testingScheduler"
            name="testingScheduler"
            component={this.renderTestingSchedulerInput}
            label={t("MSG_0205")}
            validate={[Validation.isRequired]}
            format={Mask.timeRange}
            normalize={Mask.timeRange}
          />
          <Field
            id="contactPhone"
            name="contactPhone"
            component={this.rendercontactPhoneInput}
            label={t("MSG_0206")}
            format={Mask.phone}
            normalize={Mask.algarPhone}
          />
          <div className={styles.incidentModalButtons}>
            <Button onClick={onPreviousStep} relevance="low">
              {t("MSG_0292")}
            </Button>

            <Button relevance="normal" type="submit" callToAction>
              {t("MSG_0007")}
            </Button>
          </div>
        </Form>

        <Loader isOpen={submitting} />
      </Fragment>
    );
  }
}

function createValidationSchema() {
  return Yup.object().shape({
    howFiguredTheProblem: Yup.string().required("Campo obrigatório"),

    description: Yup.string().required("Campo obrigatório"),

    internCall: Yup.string().required("Campo obrigatório"),

    testingScheduler: Yup.string().required("Campo obrigatório"),

    contactPhone: Yup.string()
      .required("Campo obrigatório")
      .matches(/^0\d{1,11}$/, {
        message: "Número de telefone inválido",
        excludeEmptyString: true,
      }),

    problemTime: Yup.string()
      .test("time", "Horário inválido", Validation.time)
      .required("Campo obrigatório"),
  });
}

ClearChannelIntermittentForm.propTypes = {
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
};

const reduxFormConfig = {
  form: "ClearChannelIntermittentForm",
  asyncValidate: asyncValidate(createValidationSchema()),
  shouldAsyncValidate,
};

const enhance = compose(
  translate(),
  connect(null, { createCommonIncident }),
  reduxForm(reduxFormConfig)
);

export default enhance(ClearChannelIntermittentForm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalClearChannel/Intermittent/ClearChannelIntermittentForm.js